import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export interface InitialState {
  calledRestaurantInfoRequest: boolean;
  calledVisitorTokenRequest: boolean;
  franchiseSlugLinkTableRequest: string;
  userOfferRequests: { lastCalledAt: number; count: number };
  getReferralCodeRequests: { lastCalledAt: number; count: number };
  getPointingRequests: { lastCalledAt: number; count: number };
}

const initialState: InitialState = {
  calledRestaurantInfoRequest: false,
  franchiseSlugLinkTableRequest: "",
  calledVisitorTokenRequest: false,
  userOfferRequests: { lastCalledAt: new Date().valueOf(), count: 0 },
  getReferralCodeRequests: { lastCalledAt: new Date().valueOf(), count: 0 },
  getPointingRequests: { lastCalledAt: new Date().valueOf(), count: 0 },
};

const requestLimiter = createSlice({
  name: "requestLimiter",
  initialState,
  reducers: {
    setCalledRestaurantInfoRequest: (state, action: PayloadAction<boolean>) => {
      state.calledRestaurantInfoRequest = action.payload;
    },
    setLinkTableRequest: (state, action: PayloadAction<string>) => {
      state.franchiseSlugLinkTableRequest = action.payload;
    },
    setCalledVisitorTokenRequest: (state, action: PayloadAction<boolean>) => {
      state.calledRestaurantInfoRequest = action.payload;
    },
    sendUserOfferRequest: (state) => {
      const now = new Date();
      if (
        Math.abs(now.valueOf() - state.userOfferRequests.lastCalledAt) /
          (1000 * 60) >
        1
      ) {
        // reset count after one minute
        state.userOfferRequests = {
          lastCalledAt: new Date().valueOf(),
          count: 1,
        };
      } else {
        state.userOfferRequests.count += 1;
      }
    },
    sendGetReferralCodeRequest: (state) => {
      const now = new Date();
      if (
        Math.abs(now.valueOf() - state.getReferralCodeRequests.lastCalledAt) /
          (1000 * 60) >
        1
      ) {
        // reset count after one minute
        state.getReferralCodeRequests = {
          lastCalledAt: new Date().valueOf(),
          count: 1,
        };
      } else {
        state.getReferralCodeRequests.count += 1;
      }
    },
    sendGetPointingRequest: (state) => {
      const now = new Date();
      if (
        Math.abs(now.valueOf() - state.getPointingRequests.lastCalledAt) /
          (1000 * 60) >
        1
      ) {
        // reset count after one minute
        state.getPointingRequests = {
          lastCalledAt: new Date().valueOf(),
          count: 1,
        };
      } else {
        state.getPointingRequests.count += 1;
      }
    },
  },
});

export const {
  setCalledRestaurantInfoRequest,
  setLinkTableRequest,
  setCalledVisitorTokenRequest,
  sendUserOfferRequest,
  sendGetReferralCodeRequest,
  sendGetPointingRequest,
} = requestLimiter.actions;

export default requestLimiter.reducer;
